// extracted by mini-css-extract-plugin
export default {"matrix":"AddExercisesBox_matrix__Ui2wm"};